<template>
    <el-tag
      :size="size?size: 'medium'"
      v-bind:style="
        !selected
          ? { 'border': `1px ${item.color} solid`, color: item.color, 'background-color': '#fff', margin: '1px 4px 3px 1px' }
          : {
              color: '#FFFFFF',
              'background-color': `${item.color}`,
              'border': `1px ${item.color} solid`,
              margin: '1px 4px 3px 1px',
            }
      "
      effect="dark"
      class="pointer"
    >
      <div class="d-flex">
        <span class="me-1" v-if="item.assign === true">*</span>
        <div v-if="isButton && selected" class="font-size-14 text-center text-white" style="border-radius: 2px">
          {{ item.name }}
        </div>
        <div v-if="isButton && !selected" class="font-size-14 text-center" style="border-radius: 2px">{{ item.name }}</div>
        <div v-if="!isButton && !selected" class="font-size-16 text-center">{{ item.name }}</div>
      </div>
    </el-tag>
  </template>
  
  <script>
  export default {
    name: "TagCustomV2",
    props: ["item", "selected", "isButton", "size"],
    methods: {
  },
  mounted() {
  
  }
  };
  </script>
  

<style scoped>
.text-white{
    color: #FFFFFF;
}
</style>
  